/** Audit log API endpoints, merged into the platform API client. */
export const auditApiEndpoints: Record<string, string> = {
  auditEvents: "/ext/audit/events/",
  auditVerify: "/ext/audit/verify/",
  auditForward: "/ext/audit/forward/",
  saveAuditForward: "PUT:/ext/audit/forward/",
  removeAuditForward: "DELETE:/ext/audit/forward/",
  testAuditForward: "POST:/ext/audit/forward/test/",
};
